import axios from "axios";
import React, { useState } from "react";
import Swal from "sweetalert2";
import "./css/main.login.css";
import Register from "../register/Register";

const Login: React.FC = () => {
  const Cookies = require("js-cookie");

  const [isShowLoginForm, setIsShowLoginForm] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [isRegister, setIsRegister] = useState(false);

  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [loginErrors, setLoginErrors] = useState({
    userName: "",
    password: "",
    form: "",
  });

  const handleLogin = async (e?: React.FormEvent) => {
    e?.preventDefault();
    const nextErrors = {
      userName: userName.trim() === "" ? "Vui lòng nhập tên tài khoản" : "",
      password: password.trim() === "" ? "Vui lòng nhập mật khẩu" : "",
      form: "",
    };

    if (nextErrors.userName || nextErrors.password) {
      setLoginErrors(nextErrors);
      return;
    } else if (userName.trim() !== "" && password.trim() !== "") {
      setLoginErrors({ userName: "", password: "", form: "" });
      try {
        Swal.fire({
          title: "Đang xử lý...",
          text: "Vui lòng đợi giây lát",
          customClass: {
            popup: "custom-swal",
            title: "custom-title",
            htmlContainer: "custom-text",
          },
          allowOutsideClick: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });

        // Chờ 3 giây
        await new Promise((resolve) => setTimeout(resolve, 1000));
        await axios
          .post(`${process.env.REACT_APP_URL_API}/auth/login`, {
            username: userName,
            password,
          })
          .then(async (data) => {
            localStorage.setItem(
              "user_info",
              JSON.stringify({
                userName: data.data.user.username,
                coins: data.data.user.coins,
                role: data.data.user.role,
                id: data.data.user._id,
              })
            );

            Cookies.set("access_token", data.data.access_token, {
              expires: 1 / 24,
              secure: false, // Thử false cho iOS
              sameSite: "Lax", // Thử Lax thay vì Strict
            });

            await new Promise((resolve) => setTimeout(resolve, 100));

            if (data.status === 201 && (data.data.user.role === "SUPERADMIN" || data.data.user.role === "ADMIN")) {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/admin";
              }, 500);
            } else {
              Swal.fire({
                icon: "success",
                title: "Đăng nhập thành công",
                text: "Vui lòng đợi ít phút. ",
                customClass: {
                  popup: "custom-swal",
                  title: "custom-title",
                  htmlContainer: "custom-text",
                },
              });
              setTimeout(() => {
                window.location.href = "/";
              }, 500);
            }
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Swal.close();
              setLoginErrors({
                userName: "",
                password: "",
                form: "Tài khoản hoặc mật khẩu không chính xác",
              });
            } else {
              Swal.close();
              setLoginErrors({
                userName: "",
                password: "",
                form: "Đăng nhập thất bại, vui lòng thử lại",
              });
            }
          });
      } catch (error) {
        Swal.close();
        return error;
      }
    }
  };

  return (
    <div className="login-page ">
      <div className="bgLogin">
        <video
          className="bgLogin-video bgLogin-video-desktop"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/assets/bg-pc.mp4" type="video/mp4" />
        </video>
        <video
          className="bgLogin-video bgLogin-video-mobile"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/assets/bg-mb.mp4" type="video/mp4" />
        </video>
      </div>
      <div
        className={`model-group ${
          isShowLoginForm || isRegister || isLogin ? "active" : ""
        }`}
      >
        <div className="overlay"></div>

        {/* Login Modal */}
        <div
          className={`model-item model-login ${
            isShowLoginForm || isLogin ? "model-login_active" : ""
          }  `}
        >
          <div
            className="btn-closeModel"
            onClick={() => {
              setIsShowLoginForm(false);
              setIsLogin(false);
            }}
          ></div>
          <img src="/assets/text-login.png" alt="Đăng nhập" className="miniTxt" width={248} height={142} />

          <div className="wrapper">
            <form id="loginform" onSubmit={handleLogin}>
              <input
                className="bg-input mb-3"
                type="text"
                id="txtUsername"
                placeholder="Nhập tên tài khoản"
                onChange={(e) => {
                  setUserName(e.target.value);
                  if (loginErrors.userName || loginErrors.form) {
                    setLoginErrors((prev) => ({
                      ...prev,
                      userName: "",
                      form: "",
                    }));
                  }
                }}
                maxLength={16}
                minLength={4}
                autoComplete="off"
              />
              {loginErrors.userName && (
                <p className="login-error-message">{loginErrors.userName}</p>
              )}
              <input
                className="bg-input mb-3"
                type="password"
                id="txtPassword"
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (loginErrors.password || loginErrors.form) {
                    setLoginErrors((prev) => ({
                      ...prev,
                      password: "",
                      form: "",
                    }));
                  }
                }}
                placeholder="Nhập mật khẩu"
                maxLength={16}
                minLength={4}
                autoComplete="off"
              />
              {loginErrors.password && (
                <p className="login-error-message">{loginErrors.password}</p>
              )}
              {loginErrors.form && (
                <p className="login-error-message">{loginErrors.form}</p>
              )}
              <div className="group-btn mt-4">
                <button type="button" className="btn-cancel" onClick={() => {
                  setIsShowLoginForm(false);
                  setIsLogin(false);
                }}></button>
                <button
                  type="submit"
                  className="btn-confirm"
                  onClick={handleLogin}
                ></button>
              </div>
            </form>
            <p className="txt-swith">
              Chưa có tài khoản?{" "}
              <span
                className="link-register"
                onClick={() => {
                  setIsShowLoginForm(false);
                  setIsRegister(true);
                }}
              >
                Đăng ký ngay
              </span>
            </p>
          </div>
        </div>

        {/* Register Modal */}
        <Register
          isRegister={isRegister}
          setIsShowLogin={() => setIsLogin(true)}
          setIsRegister={() => setIsRegister(false)}
        />
      </div>

      <div className="index-page_wrapper">
        <div className="logo">
          <img
            src="/assets/logo-login.png"
            alt="Logo"
            className="logo_main"
          />
          <div className="wrapper-content">
            <div className="group-btn">
              <div
                className="btn-item btn-login"
                style={{ backgroundImage: "url('/assets/btn-login.png')" }}
                onClick={() => {
                  setIsShowLoginForm(true);
                }}
              ></div>
              <div
                className="btn-item btn-register"
                style={{ backgroundImage: "url('/assets/btn-regis.png')" }}
                onClick={() => {
                  setIsRegister(true);
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
